'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('SsoEmailCtrl', SsoEmailCtrl);

  SsoEmailCtrl.$inject = ['$stateParams', '$log', '$scope', 'onboardingRouter', 'providerSvc', 'authenticationSvc', 'organization'];

  function SsoEmailCtrl($stateParams, $log, $scope, onboardingRouter, providerSvc, authenticationSvc, organization) {
    var vm = this;
    var provider = {};
    vm.ssoAuthView = authenticationSvc.getCurrentSsoInfo();
    vm.organizationName = vm.cobrandingText = organization.name;
    vm.showLearnMore = false;
    vm.learnMore = _learnMore;
    vm.submit = _submit;
    vm.customError = null;
    vm.uniqueEmail = '';
    _init();

    function _init() {
      var INVALID_EMAIL_ERROR_CODE = 'INVALID_EMAIL_ADDRESS';
      var USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS';

      // Catch error from resolved organization
      if (organization.errorCode || !vm.ssoAuthView || !vm.ssoAuthView.attributesView) {
        onboardingRouter.navigateSsoError({
          contact: true
        });
        return;
      }

      // Set custom error message
      if ($stateParams.error && $stateParams.error.errorCode === INVALID_EMAIL_ERROR_CODE) {
        vm.customError = $stateParams.error.message;
      }
      if ($stateParams.error && $stateParams.error.errorCode === USER_ALREADY_EXISTS) {
        vm.customError = $stateParams.error.message;
      }

      provider = {
        organization: organization.shortName,
        accessCode: vm.ssoAuthView.attributesView.accessCode
      };

      providerSvc.setProvider(provider).then(function (resp) {
        $log.debug(resp);
        providerSvc.getHeader().then(function (data) {
          var contentItem;
          if (data && data.content) {
            contentItem = data.content.filter(function (headerContent) {
              return headerContent.target === 'image';
            })[0];
            if (contentItem) {
              vm.cobranding = contentItem.replacement;
            }
          }
        });
      });
    }

    function _learnMore() {
      vm.showLearnMore = !vm.showLearnMore;
    }

    function _submit() {
      if (!$scope.form.$valid) {
        $scope.form.email.$setDirty();
        return;
      }

      if (vm.uniqueEmail.length > 0) {
        vm.ssoAuthView.attributesView.emailAddress = vm.uniqueEmail;
      }

      authenticationSvc.setCurrentSsoInfo(vm.ssoAuthView);
      //redirect to handle the re-attempt at sso login with updated info

      if (organization && organization.shortName === 'BSC') {
        onboardingRouter.navigateSsoCustomLanding();
      } else {
        if (vm.ssoAuthView.ssoUserMetadata.isDisableAccountMerge) {
          onboardingRouter.navigateSsoLogin({ mergeDisabled: true });
        } else {
          onboardingRouter.navigateSsoLanding();
        }
      }
    }
  }
})();